<template>
    <section id="contact" class="contact-area bg-gray ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-6">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <h2 class="text-capitalize">We're here to help</h2>
                        <p class="mt-4">We’re here to help. Whether you need product support, want to customize a receipt management solution for your business, or simply wish to explore collaboration opportunities, feel free to reach out. You can also find frequently asked questions here.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <!-- Contact Box -->
                    <div class="contact-box">
                        <div class="accordion" id="accordionExample">
                            <div class="card">
                                <div class="card-header cursor-pointer" id="headingOne">
                                    <h3 data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Product & Account Support
                                    </h3>
                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="mb-3">If you are experiencing issues with the app or have questions about your account, our support team is ready to assist.</p>
                                    <p>We can help with:</p>
                                    <ul class="list-style-disc mb-3">
                                        <li>Login, verification codes, and account access</li>
                                        <li>Subscription and billing inquiries</li>
                                        <li>Data export, organization settings, and member permissions</li>
                                        <li>Troubleshooting receipt upload or processing issues</li>
                                    </ul>
                                    <p>Support Email: support@forwardreceipts.com</p>
                                    <p>Office Hours: Mon–Fri, 9:00 AM – 6:00 PM (UTC+8)</p>
                                    <p>Response Time: within 1–2 business days</p>
                                </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header cursor-pointer" id="headingTwo">
                                    <h3 data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Customized Receipt Management Solutions
                                    </h3>
                                </div>

                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="mb-3">Looking for a tailored solution for your team or company?<br/>We provide flexible and scalable options based on your business needs.</p>
                                    <p>Custom services include:</p>
                                    <ul class="list-style-disc mb-3">
                                        <li>White-label or custom-branded receipt management</li>
                                        <li>Company-level data structure and role permission setup</li>
                                        <li>Automated workflows and API integrations</li>
                                        <li>Custom export, reporting, or audit tools</li>
                                        <li>Migration support for onboarding from existing systems</li>
                                    </ul>
                                    <p>Support Email: business@forwardreceipts.com</p>
                                    <p>Office Hours: Mon–Fri, 9:00 AM – 6:00 PM (UTC+8)</p>
                                    <p>Response Time: within 1–2 business days</p>
                                </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header cursor-pointer" id="headingThree">
                                    <h3 data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        Business & Partnership Opportunities
                                    </h3>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div class="card-body">
                                    <p class="mb-3">We’re open to collaboration with businesses, developers, and platforms.</p>
                                    <p>Possible cooperation includes:</p>
                                    <ul class="list-style-disc mb-3">
                                        <li>API partnership or ecosystem integration</li>
                                        <li>Bulk subscription or enterprise plan</li>
                                        <li>Joint product development</li>
                                        <li>Reseller / distributor opportunities</li>
                                    </ul>
                                    <p>Support Email: business@forwardreceipts.com</p>
                                    <p>Office Hours: Mon–Fri, 9:00 AM – 6:00 PM (UTC+8)</p>
                                </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header cursor-pointer" id="headingFour">
                                    <h3 data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                        Media & Press Inquiries
                                    </h3>
                                </div>
                                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                    <div class="card-body">
                                        <p class="mb-3">For interviews, product information, or media requests:</p>
                                        <p>Press Contact: press@forwardreceipts.com</p>
                                        <p>Office Hours: Mon–Fri, 9:00 AM – 6:00 PM (UTC+8)</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header cursor-pointer" id="headingFive">
                                    <h3 data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                        General Inquiry
                                    </h3>
                                </div>
                                <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                    <div class="card-body">
                                        <p>Not sure where to start?</p>
                                        <p class="mb-3">Feel free to send a message and our team will direct you to the right contact</p>
                                        <p>General Contact: support@forwardreceipts.com</p>
                                        <p>Office Hours: Mon–Fri, 9:00 AM – 6:00 PM (UTC+8)</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>